import { createMigration } from './utils';

export const migrationTo9_167 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.set('musicId', map.get('audioId'));
            map.delete('audioId');
        });
    },
});
